import RIHeroSection from "./components/HeroSection";
import RICitiesDirectory from "./components/CitiesDirectory";
import RIStateResources from "./components/StateResources";
import RIFAQSection, { faqs } from "./components/FAQSection";
import RIFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import CitySEOHead from "@/components/feature/CitySEOHead";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

const seoFaqs = faqs.map(f => ({ q: f.question, a: f.answer }));

export default function RhodeIslandPage() {
  return (
    <>
      <CitySEOHead
        city="Rhode Island"
        state="Rhode Island"
        stateAbbr="RI"
        route="/states/rhode-island"
        title="Rhode Island Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Rhode Island — Providence, Warwick, Cranston, Newport, and Pawtucket. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Rhode Island, United States"
        geoPosition="41.6809;-71.5118"
        faqs={seoFaqs}
        servicesSchema={servicesList}
      />
      <div className="font-sans">
        <RIHeroSection />
        <RICitiesDirectory />
        <RIStateResources />
        <RIFAQSection />
        <SEOCrossLinks state="RI" />
        <RIFinalCTA />
      </div>
    </>
  );
}